/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

export const INFO_BANNER_SET_BANNER_TIP_VISIBLITY = 'INFO_BANNER_SET_BANNER_TIP_VISIBLITY';

export const SET_ACTIONS_STRIP_HIGHLIGHT_INDEX = 'SET_ACTIONS_STRIP_HIGHLIGHT_INDEX';

export const SET_ACTIONS_STRIP_HIGHLIGHT_BORDER_ACTIVE =
    'SET_ACTIONS_STRIP_HIGHLIGHT_BORDER_ACTIVE';

export const SET_ACTIONS_STRIP_AVAILABLE_ACTION_ITEM = 'SET_ACTIONS_STRIP_AVAILABLE_ACTION_ITEM';

export const SET_ACTIONS_STRIP_ACTION_ITEMS_COUNT = 'SET_ACTIONS_STRIP_ACTION_ITEMS_COUNT';

export const SET_IS_ACTIONS_STRIP_ACTIVE = 'SET_IS_ACTIONS_STRIP_ACTIVE';

export const SET_IS_FULL_INFO_ACTIVE = 'SET_IS_FULL_INFO_ACTIVE';

export const SET_IS_STANDARD_INFO_ACTIVE = 'SET_IS_STANDARD_INFO_ACTIVE';

export const SET_IS_TRICKPLAY_MENU_ACTIVE = 'SET_IS_TRICKPLAY_MENU_ACTIVE';

export const SET_ACTION_BUTTON_ACTIVE_POSITIONS_AVAILABLE =
    'SET_ACTION_BUTTON_ACTIVE_POSITIONS_AVAILABLE';

export const SET_ACTION_BUTTON_CURRENT_ACTIVE_INDEX = 'SET_ACTION_BUTTON_CURRENT_ACTIVE_INDEX';

export const SET_AIRING_DATA = 'SET_AIRING_DATA';

export const SET_PREVIEW_DATA = 'SET_PREVIEW_DATA';

export const UPDATE_STANDARD_INFO_TIMER = 'UPDATE_STANDARD_INFO_TIMER';

export const UPDATE_FULL_INFO_TIMER = 'UPDATE_FULL_INFO_TIMER';

export const UPDATE_TRICKPLAY_TIMER = 'UPDATE_TRICKPLAY_TIMER';

export const UPDATE_ACTION_STRIP_REFERECE = 'UPDATE_ACTION_STRIP_REFERECE';

export const SET_ENTERTING_CHANNEL_NUMBER_ENABLED = 'SET_ENTERING_CHANNEL_NUMBER_ENABLED';

export const SET_ENTERED_CHANNEL_NUMBER = 'SET_ENTERED_CHANNEL_NUMBER';

export const UPDATE_ENTERING_CHANNEL_NUMBER_ENABLED_TIMER =
    'UPDATE_ENTERING_CHANNEL_NUMBER_ENABLED_TIMER';

export const UPDATE_TRICKPLAY_BAR_LONG_KEY_PRESS_INTERVAL_ID =
    'UPDATE_TRICKPLAY_BAR_LONG_KEY_PRESS_INTERVAL_ID';

export const SET_MEDIA_BUTTON_MOUSE_OVER_INDEX = 'SET_MEDIA_BUTTON_MOUSE_OVER_INDEX';

export const SET_AIRING_DATA_STATUS = 'SET_AIRING_DATA_STATUS';
